module.exports = __webpack_public_path__ + "assets/img/icon8.ca964072.svg";